import React from 'react';
// Routing
import { Redirect, Route } from 'react-router-dom';
// Redux
import { connect } from 'react-redux';
import { IRootState } from '../../../redux';
// Providers
import { getLogonPlace } from '../../../services/login.service';
// Helpers
//import { noAccess } from '../../../helpers/loginFlow';
// Config
//import { staticConfig } from '../../../config/static';
import { FixedLoader } from '../../../components/Loader/FixedLoader';
import AnonymousLayout from '../../../components/layout/Anonymous/anonymous';
import { NoAccess, RouteWrapper } from '../../../components';

interface IAccessCheckState {
    loaded?: boolean;
    noAccess?: boolean;
}

class AccessCheck extends React.Component<ReduxType, IAccessCheckState> {
    constructor(props: ReduxType) {
        super(props);
        this.state = {
            loaded: false,
            noAccess: false,
        };
    }

    componentDidMount() {
        getLogonPlace();
        this.setState({
            noAccess: false,
            loaded: true,
        });
    }

    render() {
        return (
            <>
                {this.state.loaded ? (
                    <>
                        {this.state.noAccess && (
                            <RouteWrapper path="/noaccess" component={NoAccess} layout={AnonymousLayout} />
                        )}
                        <Route
                            exact
                            path=""
                            render={() => (this.state.noAccess ? <Redirect to="/noaccess" /> : this.props.children)}
                        />
                    </>
                ) : (
                    <FixedLoader size={this.props.mediaSize} />
                )}
            </>
        );
    }
}

const mapStateToProps = ({ appReadouts }: IRootState) => {
    return {
        mediaSize: appReadouts.mediaSize,
    };
};

type ReduxType = ReturnType<typeof mapStateToProps> & { children?: React.ReactNode };

export default connect(mapStateToProps)(AccessCheck);
